<template>
  <li>
    <div class="left-wrapper">
      <h3 v-if="product.type == 'product'"><a :href="product.permalink">{{product.name}}</a></h3>
      <h3 v-if="product.type == 'services'"><a :href="'/services/#section_'+product.slug">{{product.name}}</a></h3>
      <ul class="product-icon-links">
        <li v-if="product.pt_boocklet" >
          <a :href="product.pt_boocklet.url" target="_blank"><i class="fas fa-file-medical-alt"></i>Protocol Booklet</a>
        </li>
        <li v-if="citationCount">
          <a :href="product.permalink+'#citations'"><i class="fas fa-book"></i><span>{{citationCount}}</span> Citations</a>
        </li>
        <li v-if="product.comments_count" >
          <a :href="product.permalink+'#reviews_tab'"><i class="fas fa-comments"></i><span>{{product.comments_count}}</span> Reviews</a>
        </li>
      </ul>
      <div class="product-properties">
        <div class="flex-row" v-if="product.attributes.pa_detection_target">
          <div class="property-title">
            Specificity:
          </div>
          <div class="property-description" v-html="product.attributes.pa_detection_target"></div>
        </div>
        <div class="flex-row" v-if="product.attributes.pa_sample_type">
          <div class="property-title">
            Sample type:
          </div>
          <div class="property-description" v-html="product.attributes.pa_sample_type"></div>
        </div>
        <div class="flex-row" v-if="product.attributes.pa_sample_volume">
          <div class="property-title">
            Sample volume:
          </div>
          <div class="property-description" v-html="product.attributes.pa_sample_volume"></div>
        </div>
        <div class="flex-row" v-if="product.attributes.pa_detection_range">
          <div class="property-title">
            Detection range:
          </div>
          <div class="property-description" v-html="product.attributes.pa_detection_range"></div>
        </div>
        <div class="flex-row" v-if="product.attributes.pa_sensitivity">
          <div class="property-title">
            Sensitivity:
          </div>
          <div class="property-description" v-html="product.attributes.pa_sensitivity"></div>
        </div>
        <div class="flex-row" v-if="product.attributes.pa_regulatory_status">
          <div class="property-title">
            Use:
          </div>
          <div class="property-description" v-html="product.attributes.pa_regulatory_status"></div>
        </div>
      </div>
    </div>
    <div class="right-wrapper">
      <div class="add-product">
        <div class="inside-content centered-content">
          <div class="cat-icons">
            <div v-for="category in product.categories" :class="'icon '+category.icon"></div>
          </div>
          <div class="top-side">
            <p v-if="product.attributes.pa_category_number">Cat. No.: <strong>{{product.attributes.pa_category_number}}</strong></p>
            <p v-if="!product.delivery">
              <span class="purple-text">Please Inquire</span>
            </p>
            <p v-else="product.attributes.pa_sample_volume_cart || product.regular_price">
              <template v-if="product.attributes.pa_sample_volume_cart">{{product.attributes.pa_sample_volume_cart}}</template>
              / <span class="purple-text" v-if="product.regular_price" v-html="product.price"></span>
              <br><span class="sale-price" v-if="product.wc_regular_price" v-html="product.wc_regular_price"></span>
            </p>

            <p v-if="product.type == 'services'">
              Please get in touch to receive a quote:
            </p>
          </div>
          <a v-if="product.type == 'product' && product.delivery" href="#" class="submit-review-button" v-on:click.prevent="submit">Add to Cart</a>
          <a v-if="!product.delivery && product.type !== 'services'" :href="'/contact-us?distributor='+product.distributor.toLowerCase()" class="submit-review-button">Contact distributor</a>
          <a v-if="product.type == 'services'" :href="'/services/'+product.slug" class="submit-review-button">Request a quote</a>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import axios from 'axios'

  export default {
    name: "ProductItem",
    props: ['product','index'],
    data() {
      return {
        citationCount: 0,
      }
    },

    computed: {

    },
    methods: {
      submit : function() {
        // var form = document.getElementById('cart_'+this.product.id);
        // var formData = new FormData(form);

        let addProducts = [];
        addProducts.push({
            id: this.product.id,
          });

        jQuery.ajax({
          type: 'POST',
          url: ajax_object.ajax_url,
          data: {
            action: 'bmgrp_add_to_cart_from_list',
            products: JSON.stringify(addProducts)
          },
          success: (data) => {
            jQuery('.busket').find('span').remove();
            jQuery('.busket').append(data.total);

            this.$store.commit('SET_ADD_CART', {show: true, name: this.product.name});
            setTimeout(() => {
              this.$store.commit('SET_ADD_CART', {show: false, name: ''});
            }, 4000);

            // alert('Product added to cart')
          }
        });

        // console.log(form);
        // axios.get('/', { params: { 'add-to-cart': this.product.id }}).then((responce) => {
        //   console.log(responce);
        //
        // }, (responce) => {
        //   console.log('error');
        // });
      },
      getBizCitation: function() {
        jQuery.ajax({
          type: 'POST',
          url: 'https://www.bizgeniusapp.com/api/getData.php',
          data: {
            key: 'MTY2Mzg',
            ver: '5.5.3',
            dataType: 'citationList',
            product: this.product.biz_name,
            classes: '',
            order: 'publicationDate',
            maxnum: 100,
            showDOI: 'yes',
            showPaging: 'no',
            paging: 'append',
            paperLink: 'pubmed',
            start: 0,
            showFigure: 2
          },
          success: (data) => {
            if(typeof data.papersRawData !== "undefined") {
              this.citationCount = Number(this.product.citations_count) + Number(data.papersRawData.length);
            }
          }
        });
      },

      // SendUserStatus(status, reload) {
      //   let data = new FormData;
      //   data.append('action', 'http://bmgrp/de/product/nephrology/bioactive-sclerostin-elisa/');
      //   data.append('enctype', 'multipart/form-data');
      //
      //   axios.post('/wp-admin/admin-ajax.php', data).then(() => {
      //     if(reload) {
      //       location.reload();
      //     }
      //   });
      // },

    },
    mounted(){
      // this.citationCount = this.product.citations_count;
      this.getBizCitation();
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/ProductItem.vue